/**
 * @generated SignedSource<<9eaaf6728862fa025d90713da2d1b862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactAssignTeamMemberInput = {
  userID: string;
  userFullName: string;
  contactID: string;
  contactFirstName: string;
  contactLastName: string;
  teamMemberID: string;
  teamMemberEmail: string;
  teamMemberFirstName: string;
  feeID?: string | null;
  message?: string | null;
};
export type contactAssignTeamMemberMutation$variables = {
  input: ContactAssignTeamMemberInput;
};
export type contactAssignTeamMemberMutation$data = {
  readonly assignContactTeamMember: {
    readonly contactTeamMember: {
      readonly " $fragmentSpreads": FragmentRefs<"contactTeamMemberInlineFragment">;
    };
  };
};
export type contactAssignTeamMemberMutation = {
  variables: contactAssignTeamMemberMutation$variables;
  response: contactAssignTeamMemberMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdBy",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalRef",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactAssignTeamMemberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactAssignTeamMemberPayload",
        "kind": "LinkedField",
        "name": "assignContactTeamMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactTeamMember",
            "kind": "LinkedField",
            "name": "contactTeamMember",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "contactTeamMemberInlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "teamMember",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "memberUserProfile",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Fee",
                    "kind": "LinkedField",
                    "name": "fee",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "feeInlineFragment",
                        "selections": (v5/*: any*/)
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactAssignTeamMemberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactAssignTeamMemberPayload",
        "kind": "LinkedField",
        "name": "assignContactTeamMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactTeamMember",
            "kind": "LinkedField",
            "name": "contactTeamMember",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "memberUserProfile",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Fee",
                "kind": "LinkedField",
                "name": "fee",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45314b774c88240ba6c93d96daabb7a1",
    "id": null,
    "metadata": {},
    "name": "contactAssignTeamMemberMutation",
    "operationKind": "mutation",
    "text": "mutation contactAssignTeamMemberMutation(\n  $input: ContactAssignTeamMemberInput!\n) {\n  assignContactTeamMember(input: $input) {\n    contactTeamMember {\n      ...contactTeamMemberInlineFragment\n      id\n    }\n  }\n}\n\nfragment contactTeamMemberInlineFragment on ContactTeamMember {\n  id\n  teamMember {\n    id\n    memberUserProfile {\n      firstName\n      lastName\n      id\n    }\n  }\n  fee {\n    ...feeInlineFragment\n    id\n  }\n}\n\nfragment feeInlineFragment on Fee {\n  id\n  name\n  amount\n  createdAt\n  createdBy\n  currencyCode\n  description\n  externalRef\n  type\n}\n"
  }
};
})();

(node as any).hash = "baaeafb4a30d3b36e3aedd8bee9ed9f4";

export default node;
